import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";
import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useNavigate } from "react-router-dom";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import { StepIcon } from "./StepIcon";

import IdleTimerDisplay from "./../Shared/IdleTimerDisplay_V";
import LanguageButtons from "./../Shared/LanguageButtons";
import PhoneKeypad from "./../CustomerPhoneNumber/PhoneKeypad";
import PhoneConfirm from "./../CustomerPhoneNumber/PhoneConfirm";
import PhoneDisplay from "./../CustomerPhoneNumber/PhoneDisplay_V";
import BackspaceButton from "./../CustomerPhoneNumber/BackspaceButton";
import CircleButton from "./../Buttons/CircleButton_V";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

import KioskStepper from "./../../Components/Stepper/KioskStepper_V";
import Logo from "./../../Components/Logo_V";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";
import formatAddress from "./../../HelperFunctions/formatAddress";

import { useTheme } from "@mui/material/styles";

import { kioskstyles } from "./../../../../kioskstyles"; //TEMP

import { WORKFLOW_MODES } from "../../../../constants";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    loading,
    //errorMessage,
    isNotMobile,
    kioskkey,
    numbagpress,
    getKioskConfiguration
  } = props;

  const { getKioskTheme } = useContext(SocketIOContext);

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const { simplepost } = useContext(HttpContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const kioskverticalstyles_2 = useKioskVerticalStyles();

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // const keypadDone = async () => {
  //   console.log("next called");

  //   //Attempt Kiosk Login
  //   const res = await simplepost("/kiosk/getCustomer", {
  //     type: "phone",
  //     value: phonenumber
  //   });

  //   //console.log("CPN DEBUG res.data", res.data);

  //   //var customerName = res.data.name;
  //   var customerFirstName = res.data.firstName;
  //   var customerLastName = res.data.lastName;
  //   var customerID = res.data.uniqueID;

  //   if (res.status >= 400) {
  //     setErrorMessage(displayError(res.status));
  //     return;
  //   }

  //   setAll(
  //     //customerName, //customerName
  //     customerFirstName, //customerFirstName
  //     customerLastName, //customerLastName
  //     customerID, //customerID
  //     null, //numBags
  //     null, //numLabels
  //     null, //labelsList
  //     sessionID //sessionID
  //   );

  //   setErrorMessage("");
  //   setShowconfirmdialog(true);
  // };

  const hideConfirmDialog = async () => {
    setPhonenumber("");
    setShowconfirmdialog(false);
  };

  const displaystyleForconfirmdialog = async () => {
    Dlog("displaystyleForconfirmdialog", showconfirmdialog);

    if (showconfirmdialog) {
      return { display: "none" };
    } else {
      return { display: "block" };
    }
  };

  const backspacepress = async () => {
    let newNumber = phonenumber;

    if (newNumber.length > 0) {
      newNumber = newNumber.substring(0, newNumber.length - 1);
    }

    setPhonenumber(newNumber);
  };

  const next = async () => {
    Dlog("next called");
    customerReset();

    if (kiosktheme.bilingual) {
      setLocale("fr");
    }
    navigate("/language");
  };

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  const locationAddress = localStorage.getItem("LocationAddress");
  const locationName = localStorage.getItem("LocationName");

  const kiosktheme = getKioskTheme();
  const kioskconfiguration = getKioskConfiguration();

  useEffect(() => {
    if (kioskconfiguration == undefined || kioskconfiguration == null) {
      return navigate("/errorscreen");
    }
  }, []);

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <div style={kioskverticalstyles_2.flexBackground}>
        <div style={kioskverticalstyles_2.logo}>
          <center>
            <Logo />
          </center>
        </div>

        <div style={kioskverticalstyles_2.instructionDiv}>
          <div style={kioskverticalstyles_2.instructionVerticallyAlignDiv}>
            <Translate
              value="application.theme.wizardThanksText"
              name={formatFirstNameLastInitial(
                customerFirstName,
                customerLastName
              )}
            />
            <br />
            <Translate
              value="application.theme.wizardAddressText"
              name={locationName}
              address={formatAddress(locationAddress)}
            />
            .
            <br />
            <Translate value="application.theme.wizardReturningText" />
            <b>
              {" "}
              <Translate
                value="application.theme.wizardBagsText"
                count={numBags}
              />
            </b>
            {kioskconfiguration?.workflowMode ==
              WORKFLOW_MODES.BAGS_AND_LABELS && (
              <>
                , <Translate value="application.theme.wizardPrintingText" />{" "}
                <b>
                  <Translate
                    value="application.theme.wizardLabelsText"
                    count={numLabels}
                  />
                </b>
              </>
            )}
          </div>
        </div>

        <div
          style={{
            ...kioskverticalstyles_2.whiteDiv,
            ...kioskverticalstyles_2.flexcenterDiv
          }}
        >
          <div
            style={{
              marginTop: "5vh",
              height: "7.7vh",
              marginBottom: "7.7vh",
              width: "83vw"
            }}
          >
            <div
              class="fontSecondaryText"
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: "3.4vh",
                marginBottom: "4.5vh"
              }}
            >
              <Translate value="application.theme.thankyouThankYouText" />
            </div>
            <center>
              <div>
                {/* <CheckBoxOutlinedIcon style={{ fontSize: "6vh" }} /> */}
                <StepIcon
                  DefaultIcon={"CheckBoxOutlined"}
                  cssSizeString="6vh"
                  iconName={kiosktheme.thankyouStep1Icon}
                />
              </div>
              <div style={{ fontSize: "2vh", marginBottom: "1.5vh" }}>
                <div>
                  <b>
                    <Translate value="application.theme.thankyouStep1Header" />
                  </b>
                </div>
                <div>
                  <Translate value="application.theme.thankyouStep1Body" />
                </div>
              </div>
              <div>
                {/* <ArrowDropDownCircleIcon style={{ fontSize: "6vh" }} /> */}
                <StepIcon
                  DefaultIcon={"ArrowDropDownCircle"}
                  cssSizeString="6vh"
                  iconName={kiosktheme.thankyouStep2Icon}
                />
              </div>
              <div style={{ fontSize: "2vh", marginBottom: "1.5vh" }}>
                <div>
                  <b>
                    <Translate value="application.theme.thankyouStep2Header" />
                  </b>
                </div>
                <div>
                  <Translate value="application.theme.thankyouStep2Body" />
                </div>
              </div>
              <div>
                {/* <SentimentSatisfiedAltIcon style={{ fontSize: "6vh" }} /> */}
                <StepIcon
                  DefaultIcon={"SentimentSatisfiedAlt"}
                  cssSizeString="6vh"
                  iconName={kiosktheme.thankyouStep3Icon}
                />
              </div>
              <div style={{ fontSize: "2vh" }}>
                <div>
                  <b>
                    <Translate value="application.theme.thankyouStep3Header" />
                  </b>
                </div>
                <div>
                  <Translate
                    value="application.theme.thankyouStep3Body"
                    count={kiosktheme.daysToCount}
                  />
                </div>
              </div>
            </center>
          </div>

          {/* <span
            class="fontNormal"
            style={{
              ...kioskstyles.blackBodyText
            }}
          >
            <b>
              <Translate value="application.thankyou.dropindroparea" />
            </b>{" "}
            <span style={kioskstyles.HelperTextColor}>
              <Translate value="application.thankyou.placeindesignatedarea" />
            </span>
          </span>
          <br />
          <br />
          <div>
            <center>
              <SentimentSatisfiedAltIcon
                style={{ fontSize: "clamp(30px, 8vh, 120px)" }}
              />
            </center>
          </div>

          <span
            class="fontNormal"
            style={{
              ...kioskstyles.blackBodyText
            }}
          >
            <b>
              <Translate value="application.thankyou.thatsit" />
            </b>{" "}
            <span style={kioskstyles.HelperTextColor}>
              <Translate value="application.thankyou.refundcredited" />
            </span>
          </span> */}
        </div>

        <div style={kioskverticalstyles_2.footerDiv}>
          {/* <KioskStepper activeStep={3} backUrl={"/numlabels"} /> getKioskConfiguration={getKioskConfiguration}*/}
          <Button
            variant="contained"
            style={{
              height: "6vh",
              width: "30vw",
              fontSize: "2vh",
              marginLeft: "auto",
              marginRight: "auto",
              color: kiosktheme.buttonsTextColor,
              backgroundColor: kiosktheme.buttonsBGColor
            }}
            onClick={next}
          >
            <Translate value="application.theme.thankyouFinishButtonText" />
          </Button>
        </div>
      </div>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
